export default "<div class=\"n2p-form-input\" [ngClass]=\"{'disabled': disabled, 'has-error': hasError}\">\n  <ng-content></ng-content>\n</div>\n"